var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.861,
    height: 115.035,
    viewBox: "0 0 90.861 115.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(23478 -18668.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M2625.1,814.972l-13.741-7.916a9.757,9.757,0,0,1-3.423-3.637,9.488,9.488,0,0,1-1.45-4.779l.071-19.874a.594.594,0,0,0-1.188,0l-.071,19.874a12.026,12.026,0,0,0,5.444,9.438l13.741,7.916a5.2,5.2,0,0,1,2.282,3.946,1.311,1.311,0,0,1-.451,1.165l-47.118,27.363v-.19a6.56,6.56,0,0,0-2.876-4.969c-.238-.143-12.932-7.489-13.717-7.94a.073.073,0,0,0-.047-.024,10.865,10.865,0,0,1-4.8-8.344l.047-13.6.1-30.572c0-6.323-4.588-14.24-10.056-17.4h-.024a11.7,11.7,0,0,0-3.947-1.4l45.739-26.6c1.664-.951,3.946-.713,6.371.69,5.254,3.019,9.486,10.389,9.462,16.379l-.024,13.337a.605.605,0,0,0,.57.618h.024a.621.621,0,0,0,.594-.594l.024-13.337c.024-6.395-4.469-14.216-10.056-17.426-2.829-1.64-5.515-1.878-7.56-.689-.238.143-48.734,28.337-48.734,28.337-2.021,1.165-3.162,3.59-3.162,6.8l-.024,7.013a6.245,6.245,0,0,0,2.877,4.969,2.328,2.328,0,0,0,2.33.214c.238-.071,6.989-4.018,9.058-5.23a6.834,6.834,0,0,1,.166,1.355l-.143,44.146c0,6.728,4.755,14.953,10.6,18.329l13.74,7.94a2.431,2.431,0,0,0,2.425.166l48.758-28.314a2.435,2.435,0,0,0,1.046-2.187A6.319,6.319,0,0,0,2625.1,814.972Zm-81.66-33.234v-.19l.024-7.037c0-2.449,1.641-3.328,3.756-2.116a9.36,9.36,0,0,1,3.8,4.921Zm32.878,67.491-13.74-7.917c-5.515-3.186-10.009-10.959-10.009-17.306l.143-44.146a10.768,10.768,0,0,0-4.9-8.511c-2.877-1.664-5.54-.285-5.54,3.162l-.023,7.037c0,1.165-.665,1.545-1.688.951a5.121,5.121,0,0,1-2.282-3.947l.024-7.013c0-2.758.9-4.8,2.544-5.753h.024l.047-.048c1.926-1.094,4.446-.38,6.324.713,5.254,3.043,9.461,10.484,9.438,16.38l-.071,30.572-.048,13.6a11.974,11.974,0,0,0,5.42,9.414c.261.119,12.956,7.489,13.74,7.94a5.054,5.054,0,0,1,2.282,3.922C2578.006,849.442,2577.34,849.847,2576.318,849.229Z",
    transform: "translate(-26015.092 17932.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M2614.771,810.678a.6.6,0,0,0-.813-.215l-11.175,6.5a.6.6,0,0,0,.6,1.029l11.175-6.5A.6.6,0,0,0,2614.771,810.678Z",
    transform: "translate(-26059.492 17882.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M2664.33,775.715l16.709-9.724a.6.6,0,1,0-.6-1.028l-16.709,9.724a.595.595,0,0,0,.6,1.028Z",
    transform: "translate(-26100.871 17912.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M2617.67,817.039a.6.6,0,0,0,.3-.08l35.54-20.682a.6.6,0,0,0-.6-1.028l-35.54,20.682a.595.595,0,0,0,.3,1.109Z",
    transform: "translate(-26069.396 17892.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M2617.67,817.039a.6.6,0,0,0,.3-.08l35.54-20.682a.6.6,0,0,0-.6-1.028l-35.54,20.682a.595.595,0,0,0,.3,1.109Z",
    transform: "translate(-26068.469 17903.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M2617.67,817.039a.6.6,0,0,0,.3-.08l35.54-20.682a.6.6,0,0,0-.6-1.028l-35.54,20.682a.595.595,0,0,0,.3,1.109Z",
    transform: "translate(-26068.01 17914.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M2617.67,817.039a.6.6,0,0,0,.3-.08l35.54-20.682a.6.6,0,0,0-.6-1.028l-35.54,20.682a.595.595,0,0,0,.3,1.109Z",
    transform: "translate(-26067.896 17926.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M2620.559,965.457a.6.6,0,0,0,.3-.08l35.136-20.421a.594.594,0,0,0-.6-1.028l-35.135,20.42a.594.594,0,0,0,.3,1.109Z",
    transform: "translate(-26071.357 17791.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M2673.154,971.322,2638.327,991.6a.594.594,0,1,0,.6,1.026l34.827-20.279a.594.594,0,1,0-.6-1.026Z",
    transform: "translate(-26083.623 17772.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M2670.169,1011.5a.595.595,0,0,0,.812.216l34.59-20.112a.594.594,0,1,0-.6-1.028l-34.59,20.112A.594.594,0,0,0,2670.169,1011.5Z",
    transform: "translate(-26105.389 17759.807)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/news-icon.aa0cacaaae4aa16d903ac32afe141ded.svg";
export { ForwardRef as ReactComponent };